/**
 * Global application constants
 */

export const PARTNER_SUCCESS_EMAIL = "partner-success@poweredbylight.com";
export const DOCS_QUICKSTART_URL = "https://docs.light.dev/quickstart";

/**
 * Content-column widths the page layouts switch on, mirroring the
 * `--container-page-*` rungs in main.css. Only for layouts that swap structure
 * in JS rather than in CSS.
 */
export const PAGE_WIDTH_SM = 640;
